import { useState, useEffect, useMemo } from 'react';
import { postApiPriceComparatorGetList } from '../../../api';

export const useGetCalculations = (sortOrder: 'ASC' | 'DESC' = 'DESC') => {
	const [data, setData] = useState<any>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchCalculations = async () => {
			try {
				setLoading(true);
				setError(null);
				const result = await postApiPriceComparatorGetList();

				console.log('result', result);

				setData(result);
			} catch (err) {
				setError(err instanceof Error ? err : new Error('Unknown error'));
			} finally {
				setLoading(false);
			}
		};

		fetchCalculations();
	}, []);

	// Ordenar los resultados del lado del cliente
	const sortedData = useMemo(() => {
		if (!data?.results) return data;

		const sortedResults = [...data.results].sort((a, b) => {
			const dateA = new Date(a.createdDateUTC).getTime();
			const dateB = new Date(b.createdDateUTC).getTime();

			return sortOrder === 'DESC' ? dateB - dateA : dateA - dateB;
		});

		return {
			...data,
			results: sortedResults,
		};
	}, [data, sortOrder]);

	return { data: sortedData, loading, error };
};
